import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs/operators';
import {
  BaseCoreState,
  baseInquiryActions,
  baseInquirySelectors,
  BaseInquiryStatus,
  DefaultDeliveryTimeListItemResponse,
  DeliveryTimeItem,
  PspBranchShortInfoResponse,
} from 'base';

@Injectable({ providedIn: 'root' })
export class BaseCustomerSharedService {
  constructor(private store: Store<BaseCoreState>, private router: Router, private activatedRoute: ActivatedRoute) {}

  publishInquiryDirectly(
    inquiryId: number,
    employeesBranches: PspBranchShortInfoResponse[],
    isDefaultFilters: boolean = true,
    isDashboard: boolean = false
  ): void {
    this.store.dispatch(
      baseInquiryActions.loadDefaultDeliveryTimeList({
        payload: inquiryId,
      })
    );

    this.store
      .select(baseInquirySelectors.getDefaultDeliveryTimeList)
      .pipe(
        filter((state) => !!state.ok),
        map((state) => state.data as DefaultDeliveryTimeListItemResponse[]),
        take(1)
      )
      .subscribe((list) => {
        this.store.dispatch(
          baseInquiryActions.createCustomerDeliveryTimeList({
            payload: {
              inquiryId,
              body: {
                deliveryTimes: this.prepareDeliveryTimesPayload(list, employeesBranches),
              },
              callback: () => {
                this.updateInquiryStatus(inquiryId, isDefaultFilters, isDashboard);
              },
            },
          })
        );
      });
  }

  private prepareDeliveryTimesPayload(
    list: DefaultDeliveryTimeListItemResponse[],
    employeesBranches: PspBranchShortInfoResponse[]
  ): DeliveryTimeItem[] {
    return list.map((item) => {
      const filteredBranches = item.branches
        .filter((branchItem) => employeesBranches.some((employeeBranch) => employeeBranch.id === branchItem.id))
        .map((branchItem) => branchItem.id);

      return {
        deliveryType: item.category,
        deliveryTime: 0,
        branches: filteredBranches,
      };
    });
  }

  private updateInquiryStatus(inquiry: number, isDefaultFilters: boolean, isDashboard: boolean): void {
    this.store.dispatch(
      baseInquiryActions.updateInquiryStatus({
        payload: {
          inquiry,
          isDashboard,
          status: BaseInquiryStatus.published,
          callback: () => {
            if (!isDashboard) {
              this.redirectToInquiryList(isDefaultFilters);
            }
          },
        },
      })
    );
  }

  private redirectToInquiryList(isDefaultFilters: boolean): void {
    if (isDefaultFilters) {
      this.router.navigate(['inquiries/list'], {
        queryParams: {
          page: 1,
          status: `${BaseInquiryStatus.unpublished},${BaseInquiryStatus.published}`,
        },
      });
    } else {
      this.store.dispatch(
        baseInquiryActions.getInquiries({ payload: { ...this.activatedRoute.snapshot.queryParams, page: 1 } })
      );
    }
  }
}
